import gql from 'graphql-tag'
import { GET_LIST, GET_ONE } from 'react-admin'

// auth.users as nhost/auth tracks it: camelCase fields, `users`/`updateUsers`.
// Deliberately not wrapped in upsertQuery, which writes through
// `insert_<table>` with on_conflict — a name nhost's tables do not have. The
// plain dataProvider path takes `updateUsers` from introspection instead.
const buildFields = gql`
  {
    id
    email
    displayName
    defaultRole
    disabled
    lastSeen
    createdAt
  }
`

export const UserQueries = {
  [GET_ONE]: { buildFields },
  [GET_LIST]: { buildFields },
}
export default UserQueries
